import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROJECT_PAYMENT_FEATURE_KEY,
  ProjectPaymentState,
  ProjectPaymentPartialState,
  projectPaymentAdapter,
} from './project-payment.reducer';
import { ProjectPaymentDto } from '@cradua/data';

// Lookup the 'ProjectPayment' feature state managed by NgRx
export const getProjectPaymentState = createFeatureSelector<
  ProjectPaymentPartialState,
  ProjectPaymentState
>(PROJECT_PAYMENT_FEATURE_KEY);

const { selectAll, selectEntities } = projectPaymentAdapter.getSelectors();

export const getProjectPaymentLoaded = createSelector(
  getProjectPaymentState,
  (state: ProjectPaymentState) => state.loaded
);

export const getProjectPaymentError = createSelector(
  getProjectPaymentState,
  (state: ProjectPaymentState) => state.error
);

export const loadingProjectPayment = createSelector(
  getProjectPaymentState,
  (state: ProjectPaymentState) => state.loaded
);

export const getAllProjectPayment = createSelector(
  getProjectPaymentState,
  (state: ProjectPaymentState) => selectAll(state)
);

export const getProjectPaymentEntities = createSelector(
  getProjectPaymentState,
  (state: ProjectPaymentState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProjectPaymentState,
  (state: ProjectPaymentState) => state.selectedProjectPaymentId
);

export const getSelected = createSelector(
  getProjectPaymentEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProjectPayment,
  getSelectedId,
  (users: ProjectPaymentDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.InvoiceNo.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.PaymentDescription.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
